import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ScheduleJobFormComponent } from './schedulejob-form/schedulejob-form.component';
import { ScheduleJobComponent } from './schedulejob.component';
import { ScheduleJobRoutes } from './schedulejob.routing';

export function declaration() {
    return [ScheduleJobComponent, ScheduleJobFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ScheduleJobModule {
}

@NgModule({
    imports: [ScheduleJobModule, ScheduleJobRoutes],
    exports: [ScheduleJobModule]
})
export class ScheduleJobWithRouteModule {
}
